import HowToEnroll from './faq_answers/HowToEnroll'
import HowToAccessCerts from './faq_answers/HowToAccessCerts'
import HowToDeactivateUsers from './faq_answers/HowToDeactiveUsers'
import HowToEnrollOLT from './faq_answers/HowToEnrollOLT'
import HowToEnrollUsers from './faq_answers/HowToEnrollUsers'
import HowToManageLocations from './faq_answers/HowToManageLocations'
import HowToModifyUsers from './faq_answers/HowToModifyUsers'
import HowToMoveBranches from './faq_answers/HowToMoveBranches'
import HowToResetPassword from './faq_answers/HowToResetPassword'
import HowToRunReports from './faq_answers/HowToRunReports'
import HowToStartClass from './faq_answers/HowToStartClass'
import HowToUpdatePayment from './faq_answers/HowToUpdatePayment'
import HowToViewSchedule from './faq_answers/HowToViewSchedule'
import HowToAccessCourseMaterials from './faq_answers/HowToAccessCourseMaterials'
import HowToUpdateUserInfo from './faq_answers/HowToUpdateUserInfo'
import HowToEnrollInILTAndVILT from './faq_answers/HowToEnrollInILTAndVILT'
import HowToEnrollUsersInOLTILTVILT from './faq_answers/HowToEnrollUsersInOLTILTVILT'
import HowToViewUserTrainingActivity from './faq_answers/HowToViewUserTrainingActivity'

const faqDocs = {
  'General Users': [
    {
      question: 'How to reset password',
      answer: <HowToResetPassword />,
    },
    {
      question: 'How to enroll in a Virtual class or In-Person class',
      answer: <HowToEnroll />,
    },
    {
      question: 'How to start an online class',
      answer: <HowToStartClass />,
    },
    {
      question: 'How to access certificates and transcripts',
      answer: <HowToAccessCerts />,
    },
    {
      question:
        'How to view the Virtual Classroom or In-person Instructor-Led schedule',
      answer: <HowToViewSchedule />,
    },
    {
      question:
        'How to access course materials',
      answer: <HowToAccessCourseMaterials />,
    },
    // {
    //   question:
    //     'How to update User info (email address, password, etc)',
    //   answer: <HowToUpdateUserInfo />,
    // },
    // {
    //   question:
    //     'How to enroll in ILT and VILT',
    //   answer: <HowToEnrollInILTAndVILT />,
    // }
  ],
  'Shop Owners and Managers': [
    {
      question: 'How to add users or modify existing user profiles',
      answer: <HowToModifyUsers />,
    },
    {
      question:
        'How to Assign Training to Users in Your Shop',
      answer: <HowToEnrollUsers />,
    },
    //     {
    //   question:
    //     'How to enroll user in OLT, ILT, VILT',
    //   answer: <HowToEnrollUsersInOLTILTVILT />,
    // },
    {
      question: 'How to deactivate users',
      answer: <HowToDeactivateUsers />,
    },
    {
      question: 'How to manage multiple locations and users',
      answer: <HowToManageLocations />,
    },
    {
      question: 'How to move users between branches',
      answer: <HowToMoveBranches />,
    },
    // {
    //   question: 'How to run reports',
    //   answer: <HowToRunReports />,
    // },
    {
      question: "How to view user's training activity",
      answer: <HowToViewUserTrainingActivity/>
    }
  ],
}

export default faqDocs
